import { Settings, WinLinesType } from "../../Settings";
import { WinLinesAnimationParams, GenericWinLinesAnimation, GenericWinLinesAnimationPIXIAPP } from "./GenericWinLinesAnimation";
import { IWinLinesFactoryPIXIAPP } from "./IWinLinesFactoryPIXIAPP";
import { WinLinesAnimation } from "./WinLinesAnimation";
import { WinNumberLinesAnimation } from "./WinNumberLinesAnimation";
import { WinSquares1MarkerAnimation } from "./WinSquares1MarkerAnimation";
import { WinSquareAnimations } from "./WinSquaresAnimations";
import { WinSquaresAnimationsSpinePIXIAPP, WinSquaresAnimationsSpinePIXIAPPGridLimited, WinSquaresAnimationsSpinePIXIAPPGridLineLoopLimited, WinSquaresAnimationsSpinePIXIAPPLimitedLineLoop } from "./WinSquaresAnimationsSpinePIXIAPP";
import { WinSquareMarkesAnimations } from "./WinSquaresMarkersAnimations";

export const winLinesMap: Record<WinLinesType, (params: WinLinesAnimationParams) => GenericWinLinesAnimation> = {
    [WinLinesType.WinLinesAnimation]: function (params: WinLinesAnimationParams): GenericWinLinesAnimation {
        throw new Error("Function not implemented.");

    },
    [WinLinesType.WinSquareAnimations]: function (params: WinLinesAnimationParams): GenericWinLinesAnimation {
        return new WinSquaresAnimationsSpinePIXIAPP(params);
    },
    [WinLinesType.WinSquareMarkesAnimations]: function (params: WinLinesAnimationParams): GenericWinLinesAnimation {
        throw new Error("Function not implemented.");
    },
    [WinLinesType.WinNumberLinesAnimation]: function (params: WinLinesAnimationParams): GenericWinLinesAnimation {
        throw new Error("Function not implemented.");
    },
    [WinLinesType.WinSquare1MarkeAnimations]: function (params: WinLinesAnimationParams): GenericWinLinesAnimation {
        throw new Error("Function not implemented.");
    },
    [WinLinesType.WinSquareAnimationsLineLoopLimited]: (params: WinLinesAnimationParams): GenericWinLinesAnimation => {
        return new WinSquaresAnimationsSpinePIXIAPPLimitedLineLoop(params);
    },
    [WinLinesType.WinSquaresAnimationsSpinePIXIAPPGridLimited]: (params: WinLinesAnimationParams): GenericWinLinesAnimation => {
        return new WinSquaresAnimationsSpinePIXIAPPGridLimited(params);
    },

    [WinLinesType.WinSquaresAnimationsSpinePIXIAPPGridLineLoopLimited]: (params: WinLinesAnimationParams): GenericWinLinesAnimation => {
        return new WinSquaresAnimationsSpinePIXIAPPGridLineLoopLimited(params);
    },
}

export class WinLineTypeFactoryPIXIAPP implements IWinLinesFactoryPIXIAPP
{
   public CreateWinLinesPIXIAPP(params: WinLinesAnimationParams):GenericWinLinesAnimationPIXIAPP
    {        
        return winLinesMap[Settings.winLinesType](params) as GenericWinLinesAnimationPIXIAPP;
        // if (Settings.winLinesType == WinLinesType.WinSquareAnimations) {
        //     return new WinSquaresAnimationsSpinePIXIAPP(params);
        // }else {
        //     throw `its not implemented pixi app for ${Settings.winLinesType}`;
        // }       
        // return null
    }
}